export default "__VITE_ASSET__CUXUgIq1__"